// API endpoint
import Prismic from "prismic-javascript"
const apiEndpoint = "https://prismictestirepo.cdn.prismic.io/api/v2"
const client = Prismic.client(apiEndpoint)

export default client
